<template>
  <v-footer>
    <v-container class="text-center">
     </v-container>
  </v-footer>
</template>

<script>
export default {
  name: 'AppFooter'
}
</script>
